// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1uPkq","icon":"SortAdornment_icon__28NEI","up":"SortAdornment_up__2i4zB","down":"SortAdornment_down__2_3NV","active":"SortAdornment_active__11mUN"};